<style scoped>
.example {
  background-image: linear-gradient(138.83deg, rgb(252, 219, 97) 5.51%, rgb(251, 156, 101) 97.21%);
  border-radius: 0.8rem;
}
.v-card-border {
  outline-color: rgba(255, 255, 255, 0.5);
  outline-style: solid;
  outline-width: 0.8rem;
  border-radius: 0.8rem;
  background-color: rgb(0, 0, 0);
}
</style>

<template lang='pug'>
v-responsive(
  :aspect-ratio='1'
)
  v-card.example.pa-12(
    style='height:100%'
    flat
    v-show='calories_total'
  )
    .v-card-border.pa-6(
      style='height:100%'
    )
      canvas(
        style='height:100%'
        ref='plot'
      )
</template>

<script>
const initial_carbs =
{
  required: true
};

const initial_fat =
{
  required: true
};

const initial_protein =
{
  required: true
};

const isDark =
{
  required: true
};

const calories_carbs = function ()
{
  return this.carbs * 4;
};

const calories_fat = function ()
{
  return this.fat * 9;
};

const calories_protein = function ()
{
  return this.protein * 4;
};

const calories_total = function ()
{
  return this.calories_carbs + this.calories_fat + this.calories_protein;
};

const mounted = async function ()
{
  const backgroundColor =
  [
    // window.pattern.draw('dot', 'rgb(255, 200, 73)'),
    // window.pattern.draw('diamond-box', 'rgb(37, 205, 165)'),
    'rgb(255, 200, 73)',
    'rgb(37, 205, 165)',
    'rgb(217, 60, 149)',
    'rgb(250, 155, 101)',
  ];

  const borderColor = 'rgb(0, 0, 0)';

  const datasets =
  [{
    data:
    [
      this.calories_carbs,
      this.calories_fat,
      this.calories_protein,
    ],
    backgroundColor,
    borderColor,
  }];

  const labels =
  [
    'Carbs',
    'Fat',
    'Protein',
  ];

  const data =
  {
    labels,
    datasets,
  };

  const config =
  {
    type: 'pie',
    data,
    options:
    {
      plugins:
      {
        legend:
        {
          align: 'start',
          labels:
          {
            color: 'rgb(255, 255, 255)',
            boxWidth: 8,
            boxHeight: 8,
          }
        }
      }
    },
  };

  this.chart = new window.Chart
  (
    this.$refs.plot,
    config,
  );
};

export default
{
  computed:
  {
    calories_carbs,
    calories_fat,
    calories_protein,
    calories_total,
  },
  data()
  {
    return {
      carbs: this.initial_carbs,
      fat: this.initial_fat,
      protein: this.initial_protein,
      chart: null,
    };
  },
  mounted,
  props:
  {
    initial_carbs,
    initial_fat,
    initial_protein,
    isDark,
  },
  watch:
  {
    initial_carbs: function (initial_carbs_new)
    {
      this.carbs = initial_carbs_new;

      this.chart.data.datasets[0].data =
      [
        this.calories_carbs,
        this.calories_fat,
        this.calories_protein,
      ];

      this.chart.update();
    },
    initial_fat: function (initial_fat_new)
    {
      this.fat = initial_fat_new;

      this.chart.data.datasets[0].data =
      [
        this.calories_carbs,
        this.calories_fat,
        this.calories_protein,
      ];

      this.chart.update();
    },
    initial_protein: function (initial_protein_new)
    {
      this.protein = initial_protein_new;

      this.chart.data.datasets[0].data =
      [
        this.calories_carbs,
        this.calories_fat,
        this.calories_protein,
      ];

      this.chart.update();
    },
  },
}
</script>